module.exports = __webpack_public_path__ + "static/media/lendas-colecionaveis_768.dca9ba0a.png";